import React from 'react';

interface SkeletonLoaderProps {
    className?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ className }) => {
    return (
        <div
            role="status"
            className={`flex items-center justify-center w-full h-full bg-gray-200 rounded-lg animate-pulse ${className}`}
        >
            <span className="sr-only">Loading...</span>
        </div>
    );
};

export default SkeletonLoader;
